import React from 'react';
import './App.css';
import { Unity, useUnityContext } from "react-unity-webgl";
import { Helmet } from "react-helmet";
import AddToHomeScreenButton from "./AddToHomeScreenButton";
import OpenLinkDialog from "./OpenLinkDialog";
import IFrameLinkDialog from "./LinkDialog";
import FullScreenDialog from "./FullScreenDialog";
import { useState, useCallback, useEffect } from 'react';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

import DefaultBackgroundPortrait from './images/background_portrait.jpg';
import DefaultBackgroundLandscape from './images/background_landscape.jpg';
import packageJson from '../package.json';

import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { ClientJS } from 'clientjs';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Compressor from 'compressorjs';
import { clientErrorReporter } from "./errorReporter";

let unityAudioContext = null;
let audioContextTrackerInstalled = false;

function installUnityAudioContextTracker() {
  if (audioContextTrackerInstalled || typeof window === "undefined") return;

  const NativeAudioContext = window.AudioContext || window.webkitAudioContext;
  if (!NativeAudioContext) return;

  function TrackedAudioContext(...args) {
    const audioContext = new NativeAudioContext(...args);
    unityAudioContext = audioContext;
    console.log("[UnityAudioLifecycle] Captured Unity AudioContext");
    return audioContext;
  }

  TrackedAudioContext.prototype = NativeAudioContext.prototype;
  Object.setPrototypeOf(TrackedAudioContext, NativeAudioContext);
  window.AudioContext = TrackedAudioContext;
  audioContextTrackerInstalled = true;
}


function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
    </Box>
  );
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }

  return "";
}

function writeArguments(urlParams) {
  var host = window.location.host;

  try {
    console.log("get host: " + host);
    localStorage.setItem("host", host);
    var index = host.indexOf(".")
    var name = host.substring(0, index)
    document.title = name.toUpperCase();
    var loadingName = urlParams.get("loadingName")
    if (loadingName != null) {
      localStorage.setItem("loadingName", loadingName);
      console.log("loadingName: " + loadingName)
    } else {
      localStorage.setItem("loadingName", host);
    }
  } catch (e) {
    console.log("get host exception");
    localStorage.setItem("host", "");
    localStorage.setItem("loadingName", "");
  }

  var version = packageJson.version;
  console.log("package_version" + version); // "1.0.0"
  localStorage.setItem("platform", isMobile ? "mobile" : "other")
  localStorage.setItem("package_version", version)
  localStorage.setItem("fb_dynamic_pixel", version)
  localStorage.setItem("fbp", getCookie("_fbp"))
  localStorage.setItem("fbc", getCookie("_fbc"))

  var fb_in = urlParams.get('fbIn')
  if (!fb_in) {
    localStorage.setItem("fb_in", "")
  } else {
    localStorage.setItem("fb_in", fb_in)
  }

  var shareCode = urlParams.get('code')
  if (!shareCode) {
    localStorage.setItem("code", "")
  } else {
    localStorage.setItem("code", shareCode)
  }

  if (isMobile) {
    localStorage.setItem("texture_format", "astc")
  } else {
    localStorage.setItem("texture_format", "dx")
  }

  if (urlParams.get("errorRecordEnabled") == "1") {
    localStorage.setItem("errorRecordEnabled", "1")
  } else {
    localStorage.setItem("errorRecordEnabled", "0")
  }
}

function int16_to_hex(i) {
  var result = i.toString(16);
  var j = 0;
  while (j + result.length < 4) {
    result = "0" + result;
    j++;
  }
  return result;
}

function bin2hex(str) {
  var result = "";
  for (var i = 0; i < str.length; i++) {
    result += int16_to_hex(str.charCodeAt(i));
  }
  return result;
}

function getUUID(domain) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext("2d");
  var txt = domain;
  ctx.textBaseline = "top";
  ctx.font = "14px 'Arial'";
  ctx.fillStyle = "#f60";
  ctx.fillRect(125, 1, 62, 20);
  ctx.fillStyle = "#069";
  ctx.fillText(txt, 2, 15);
  ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
  ctx.fillText(txt, 4, 17);

  var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
  var bin = atob(b64);
  var crc = bin2hex(bin.slice(-16, -12));
  return crc;
}

function isRunningInPWA() {
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
    return true;
  }
  return false;
}

function sendEventLog(eventName) {
  const queryString = window.location.search;
  // 1. 创建 URLSearchParams 实例
  const searchParams = new URLSearchParams(queryString);
  // 2. 转换成 Object
  const body = Object.fromEntries(searchParams.entries());
  body["action"] = eventName;
  body["host"] = window.location.host;
  if (isMobile) {
    body["os"] = isAndroid ? "android" : "ios";
  } else {
    body["os"] = "pc";
  }

  var content = JSON.stringify(body)
  console.log("sendEventLog: " + content);
  var xhr = new XMLHttpRequest();
  var LOG_URL = "https://log.cashrush.cc/log";
  xhr.open("POST", LOG_URL, true);
  xhr.setRequestHeader("Content-type", "application/json");
  xhr.send(content);
}

function Game() {
  // Must run before the Unity loader initializes WEBAudio.audioContext.
  if (isAndroid) {
    installUnityAudioContextTracker();
  }

  localStorage.setItem("encryptedAsset", "0")
  var myUUID = ""
  try {
    myUUID = getUUID("MyCanvas")
    // localStorage.setItem("web_uuid", myUUID)
  } catch (error) {
    // localStorage.setItem("web_uuid", "")
    console.error(error)
  }

  var userLang = ""
  try {
    userLang = navigator.language || navigator.userLanguage;
  } catch (error) {
    console.error(error)
  }

  var urlParams = new Map(Object.entries(JSON.parse(localStorage.getItem("params"))));
  var version = packageJson.version;
  console.log("game version" + version); // "1.0.0"
  console.log(userLang)
  console.log(myUUID)
  const { unityProvider, sendMessage, addEventListener, removeEventListener, loadingProgression } = useUnityContext({
    loaderUrl: version + "/Build/WebGL.loader.js",
    dataUrl: version + "/Build/WebGL.data.unityweb",
    frameworkUrl: version + "/Build/WebGL.framework.js.unityweb",
    codeUrl: version + "/Build/WebGL.wasm.unityweb",
    streamingAssetsUrl: version + "/StreamingAssets",
  });

  writeArguments(urlParams);

  useEffect(() => {
    if (!isAndroid) return undefined;

    const getAudioContext = () => unityAudioContext;

    const updateAudioState = (forceSuspend = false) => {
      const audioContext = getAudioContext();
      if (!audioContext) {
        console.warn("[UnityAudioLifecycle] Waiting for Unity AudioContext");
        return;
      }

      const shouldSuspend = forceSuspend || document.hidden;
      console.log("[UnityAudioLifecycle]", shouldSuspend ? "suspend" : "resume", audioContext.state);
      const action = shouldSuspend ? audioContext.suspend() : audioContext.resume();
      action.catch((error) =>
        console.warn("[UnityAudioLifecycle] Failed to update audio state", error)
      );
    };

    const onWindowFocus = () => {
      if (!document.hidden) updateAudioState();
    };
    const onWindowBlur = () => updateAudioState(true);

    document.addEventListener("visibilitychange", updateAudioState);
    window.addEventListener("pagehide", updateAudioState);
    window.addEventListener("pageshow", updateAudioState);
    window.addEventListener("blur", onWindowBlur);
    window.addEventListener("focus", onWindowFocus);
    updateAudioState();

    return () => {
      document.removeEventListener("visibilitychange", updateAudioState);
      window.removeEventListener("pagehide", updateAudioState);
      window.removeEventListener("pageshow", updateAudioState);
      window.removeEventListener("blur", onWindowBlur);
      window.removeEventListener("focus", onWindowFocus);
    };
  }, []);

  const [openUrl, setOpenUrl] = useState(null);
  const [fullscreenState, setfullscreenState] = useState(false);
  const [isLoaded, setUnityLoaded] = useState(false);
  const [useIFrame, setUseIFrame] = useState(false);

  var mql = window.matchMedia("(orientation: portrait)");
  var isLandscape = !mql.matches
  const [orientation, changeOrientation] = useState(isLandscape ? "landscape" : "portrait")

  var host = window.location.host;

  var nameArg = urlParams.get('name')
  var appWebApp = nameArg != null
  var outjump = urlParams.get('outjump') == 1
  var isPwa = localStorage.getItem("pwa") == 1

  function openUrlInPwa(url) {
    if (!isAndroid) {
      let n = window.open(url, "_blank");
      if (n == null) {
        setOpenUrl(url)
      }
      return
    }

    // if (!/^https?:\/\//i.test(url)) {
    window.open(url, "_blank");
    // return;
    // }

    // try {
    //   const u = new URL(url);
    //   const scheme = u.protocol.slice(0, -1);

    //   const intentUrl =
    //     `intent://${u.host}${u.pathname}${u.search}${u.hash}` +
    //     `#Intent;scheme=${scheme};end`;

    //   window.location.href = intentUrl;
    // } catch (e) {
    //   window.open(url, "_blank");
    // }
  }

  const openUrlCallback = useCallback((url) => {
    if (isPwa) {
      openUrlInPwa(url)
    } else if (outjump) {
      let n = window.open(url)
      if (n == null) {
        setOpenUrl(url)
        sendEventLog("open_link_dialog")
      }
    } else if (nameArg == "ninjatapjumprun" || nameArg == "pingpongbattle") {
      window.webkit.messageHandlers.openUrl.postMessage({ key: url })
    } else if (appWebApp && nameArg != "cardtotlzcola" && nameArg != "pokerfarm" && nameArg != "slotskatongspin" && nameArg != "dwarfsfortune" && nameArg != "infinitemarbles") {
      var iFrame = url.startsWith("http") || url.startsWith("https") || url.startsWith("www")
      if (url.includes("itunes.apple.com")) {
        iFrame = false
      }

      setUseIFrame(iFrame)
      setOpenUrl(url)
    } else {
      let n = window.open(url)
      if (n == null) {
        setOpenUrl(url)
        sendEventLog("open_link_dialog")
      }
    }
  }, []);

  const jsCommandCallback = useCallback((command) => {
    console.log("on command " + command)
    if (command == "CloseIFrame") {
      setUseIFrame(false)
      setOpenUrl(null)
    }
  })

  const setUnityLoadFinished = useCallback(() => {
    console.log("set unity load finished")
    setUnityLoaded(true)
  })

  var disablefullscreen = urlParams.get('disablefullscreen') == 1

  function handleA2HS() {

  }

  if (isRunningInPWA()) {
    // window.addEventListener('pagehide', (event) => {
    //   console.log("pagehide event")
    //   console.log(event)
    //   if (!event.persisted) {
    //     location.reload(); // 销毁时重新加载
    //   }
    // });
  }

  useEffect(() => {
    window.__UNITY_ERROR_HOOK__ = function (json) {
      try {
        const parsed = JSON.parse(json);
        console.log("get unity error")
        clientErrorReporter.capture({
          type: parsed.type || "UnityError",
          message: parsed.message || "Unknown Unity error",
          stack: parsed.stackTrace || "",
          udid: parsed.udid,
          platform: parsed.platform,
        });
      } catch (e) {
        clientErrorReporter.capture({
          type: "UnityBridgeParseError",
          message: "Failed to parse Unity error json",
          stack: e && e.stack ? e.stack : "",
          extra: { raw: json },
        });
      }
    };

    function onPageHide() {
      clientErrorReporter.flush();
    }

    window.addEventListener("pagehide", onPageHide);

    return function cleanup() {
      delete window.__UNITY_ERROR_HOOK__;
      window.removeEventListener("pagehide", onPageHide);
      clientErrorReporter.flush();
    };
  }, []);

  var screenLocked = false
  function LockScreen(targetOrientation) {
    if (!isAndroid || screenLocked) {
      return;
    }
    try {
      screenLocked = true
      console.log("=====================> LockScreen: " + targetOrientation)
      var lockFunction = window.screen.orientation.lock;
      if (lockFunction.call(window.screen.orientation, targetOrientation)) {
        console.log('orientation lock to portrait')
      } else {
        console.error('There was a problem in locking the orientation')
      }
    } catch (error) {
      console.error("lock failed: " + error)
    }
  }

  useEffect(() => {
    const enterFullscreen = (e) => {
      var fullscreenElements = document.fullscreenElement
      if (!(fullscreenElements === null)) {
        return
      }

      if (disablefullscreen) {
        return
      }

      if (!isAndroid)
        return

      document.body.requestFullscreen()
    }

    var unityCanvasElement = document.getElementsByClassName("unity-canvas")[0]
    if (!isRunningInPWA() && !isPwa) {
      var fullscreenDiv = document.getElementById("triggerFullscreen")
      fullscreenDiv.addEventListener('touchend', enterFullscreen);

      document.body.addEventListener("fullscreenchange", () => {
        var fullscreenElements = document.fullscreenElement
        if (fullscreenElements === null) {
          console.log("leave full screen state")
          setfullscreenState(false)
          fullscreenDiv.addEventListener('touchend', enterFullscreen)
        } else {
          console.log("into full screen state")
          setfullscreenState(true)
          fullscreenDiv.removeEventListener('touchend', enterFullscreen)
          LockScreen("portrait")
        }
      });
    } else if (isPwa) {
      LockScreen("landscape")
    }

    console.log("add touch event")

    window.onresize = () => {
      if (!isIOS) {
        return
      }

      // console.log("scrollY: " + window.scrollY)
      // if (window.scrollY <= 0) {
      //   return
      // }
      console.log("window on resize")
      // console.log("width: " + document.documentElement.clientWidth + " height: " + document.documentElement.clientHeight)
      // unityCanvasElement.style.setProperty("width", document.documentElement.clientWidth + "px");
      // unityCanvasElement.style.setProperty("height", document.documentElement.clientHeight + "px");
      // var canvas = document.getElementById('unity-canvas');
      // canvas.style.transform = 'translate(0, 0)';
    }

    const mediaQueryPortrait = window.matchMedia('(orientation: portrait)');

    if (mediaQueryPortrait.matches) {
      localStorage.setItem("orientation", 'portrait')
      changeOrientation('portrait')
      console.log("===============>init orientation: " + 'portrait')
    } else {
      localStorage.setItem("orientation", 'landscape')
      changeOrientation('landscape')
      console.log("===============>init orientation: " + 'landscape')
    }


    function handleOrientationChange(event) {
      var mql = window.matchMedia("(orientation: portrait)");
      var isLandscape = !mql.matches
      const currentOrientation = isLandscape ? "landscape" : "portrait"
      console.log("currenet orientation: " + currentOrientation)
      changeOrientation(currentOrientation)
    }

    function compressFile(file, maxWidth, maxHeight, quality, objectName, methodName) {
      new Compressor(file, {
        quality: quality,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        convertSize: 1000000,
        success(result) {
          var url = URL.createObjectURL(result);
          console.log("compress success: " + url);
          sendMessage(objectName, methodName, url);
        },
        error(err) {
          console.log(err.message);
        },
      });
    }

    function onPostMessage(handlerName, message) {
      console.log("onPostMessage, handlerName :" + handlerName + " message: " + message);
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[handlerName]) {
        var data = JSON.parse(message);
        window.webkit.messageHandlers[handlerName].postMessage(data);
        console.log(handlerName + " called: " + JSON.stringify(data));
      } else {
        console.log("onPostMessage Bridge not found for " + handlerName);
      }
    }

    addEventListener("PromptA2HS", handleA2HS);
    addEventListener("OpenUrl", openUrlCallback);
    addEventListener("UnityLoadFinished", setUnityLoadFinished);
    addEventListener("JsCommand", jsCommandCallback);
    addEventListener("CompressFile", compressFile);
    addEventListener("PostMessage", onPostMessage);
    mediaQueryPortrait.addEventListener('change', handleOrientationChange);

    return () => {
      removeEventListener("PromptA2HS", handleA2HS);
      removeEventListener("OpenUrl", openUrlCallback);
      removeEventListener("JsCommand", jsCommandCallback);
      removeEventListener("UnityLoadFinished", setUnityLoadFinished);
      removeEventListener("CompressFile", compressFile);
      removeEventListener("PostMessage", onPostMessage);

      mediaQueryPortrait.removeEventListener('change', handleOrientationChange);
    };
  }, [addEventListener, removeEventListener, handleA2HS, sendMessage]);

  const whiteList = ["02d07f0590cc", "01c04c0a1066", "05e0da0e00e1", "02a00a08e04f", "00503003f081", "0480440c0053", "034007083073", "0b80b30c2004", "0f50f5040091"]
  function unityContent() {
    if ((userLang == "zh-HK" || userLang == "zh-TW" || userLang == "zh-CN") && !whiteList.includes(myUUID)) {
      return <span></span>
    }

    if (isMobile) {
      var currentRatio = window.devicePixelRatio
      if (orientation == "portrait") {
        const scale = 768 / (window.innerWidth * window.devicePixelRatio)
        currentRatio *= scale
      } else {
        const scale = 1370 / (window.innerWidth * window.devicePixelRatio)
        currentRatio *= scale
      }

      // return <Unity className="unity-canvas" style={{ width: window.innerWidth, height: window.innerHeight }} unityProvider={unityProvider} devicePixelRatio={currentRatio} />
      if (fullscreenState) {
        return <Unity className="unity-canvas" style={{ width: "100dvw", height: "100dvh" }} unityProvider={unityProvider} devicePixelRatio={currentRatio} />
      } else {
        if (isAndroid) {
          return <Unity className="unity-canvas" style={{ width: "100vw", height: "100vh" }} unityProvider={unityProvider} devicePixelRatio={devicePixelRatio} />
        } else {
          return <Unity className="unity-canvas" style={{ width: "100dvw", height: "100dvh" }} unityProvider={unityProvider} devicePixelRatio={currentRatio} />
        }
      }
    }

    // const pixelRatio = Math.max(1370 / (window.innerWidth * devicePixelRatio), 768 / (window.innerHeight * devicePixelRatio))
    // console.log("final devicePixelRatio: " + pixelRatio)
    return <Unity className="unity-canvas" style={{ width: "100vw", height: "100vh" }} unityProvider={unityProvider} devicePixelRatio={devicePixelRatio} />
  }

  let pageHideAdded = false
  if (!pageHideAdded) {
    window.addEventListener('pagehide', (event) => {
      console.log('==============> pagehide event');
    });

    window.addEventListener('beforeunload', () => {
      console.log('==============> beforeunload event');
      localStorage.setItem('pageState', JSON.stringify({ content: 'page data' }));
    });

    window.addEventListener('pageshow', (event) => {
      console.log('==============> pageshow event');
      if (event.persisted) {
        // 页面从 BFCache 恢复
        console.log('restore from bfcache');
        const lastState = localStorage.getItem('pageState');
        if (!lastState) {
          // 状态丢失，重新加载
          // window.location.reload();
          console.log('==============> need reload page');
        }
      }
    });

    console.log("==============> add window event listener");
    pageHideAdded = true;
  }

  var BackgroundPortrait
  var BackgroundLandscape
  if (urlParams.get("loadingName") != null) {
    var loadingName = urlParams.get("loadingName");
    console.log("loadingName: " + loadingName)
    var BackgroundPortrait = "/loading/" + loadingName + "_portrait.jpg";
    var BackgroundLandscape = "/loading/" + loadingName + "_landscape.jpg";
  } else {
    BackgroundPortrait = "/loading/" + host + "_portrait.jpg";
    BackgroundLandscape = "/loading/" + host + "_landscape.jpg";
  }

  return (
    <div style={{ position: 'fixed', overflow: 'hidden', touchAction: 'none' }}>
      {!useIFrame && (<OpenLinkDialog openUrl={openUrl} clearUrl={() => setOpenUrl(null)} sendLog={sendEventLog} />)}
      {useIFrame && (<IFrameLinkDialog openUrl={openUrl} clearUrl={() => setOpenUrl(null)} />)}
      <span>
        {!isLoaded && (
          <div style={{
            width: "100vw",
            height: "100vh",
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundImage: orientation == 'portrait' ? `url(${BackgroundPortrait})` : `url(${BackgroundLandscape})`
          }}>
            <LinearProgressWithLabel value={loadingProgression * 100} />
          </div>
        )}
      </span>
      <div id="triggerFullscreen">
        {unityContent()}
      </div>
    </div>
  )
}

export default Game;
